import React from 'react';
import InlineEdit from 'react-edit-inline';

export default function TableComment({comment, onChange, editingClassName}) {
  return (
    <InlineEdit
      placeholder="Добавить комментарий"
      activeClassName={editingClassName}
      text={comment}
      paramName="text"
      change={onChange}
      maxLength={40}
    />
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/Cart/elements/tableElements/TableComment.jsx
 **/